import styles from "../../../styles/Participant-Employment.module.css"
import { careerProfileLabels } from "../Types/careerProfileLabels"
import FormMenu from "./FormMenu"
import FormContent from "./FormContent"
import { useState } from "react"
import { useFormik } from "formik"
import { useContext } from "react"
import { UserContext } from "../../../context/userContext"
import { employmentApiUrl } from "../../../config/microservicesUrls"
import axios from "axios"
import { useEffect } from "react"
import { validateEmail } from "../Utils/Utils"

const CareerProfileForm = ({ closeForm, editCareerProfile, update }) => {
  const [activeForm, setActiveForm] = useState(
    careerProfileLabels.workGoals.title
  )
  const [extraEducationSections, setExtraEducationSections] = useState(false)
  const { v4: uuidv4 } = require("uuid")
  const [loading, setLoading] = useState(false)

  const userCtx = useContext(UserContext)

  const formik = useFormik({
    initialValues: {
      workGoals_1: "",
      workGoals_2: "",
      workGoals_3: "",
      workGoals_4: "",
      workGoals_5: "",
      workGoals_6: "",
      education_1: "",
      education_1a: "",
      education_2: "",
      education_3: "",
      education_3a: undefined,
      education_4: "",
      education_4a: "",
      education_5: "",
      education_5a: "",
      education_6: "",
      education_6a: "",
      education_6b: "",
      education_6c: "",
      education_6d: "",
      education_6e: "",
      education_6e1: undefined,
      education_6f: "",
      education_6g: "",
      education_6h: "",
      education_6i: "",
      education_6i1: "",
      education_6i2: "",
      education_6i3: "",
      education_6j: "",
      pastEducation_1: "",
      pastEducation_1a: "",
      pastEducation_2: "",
      pastEducation_2a: "",
      pastEducation_3: "",
      pastEducation_3a: "",
      pastEducation_4: "",
      pastEducation_4a: "",
      pastEducation_5: "",
      pastEducation_5a: "",
      pastEducation_6: "",
      pastEducation_6a: "",
      pastEducation_7: "",
      pastEducation_7a: "",
      pastEducation_8: "",
      pastEducation_8a: "",
      pastEducation_9: "",
      pastEducation_9a: "",
      pastEducation_10: "",
      pastEducation_10a: "",
      pastEducation_10b: "",
      pastEducation_11: "",
      pastEducation_12: "",
      pastEducation_12a: "",
      pastEducation_12b: "",
      pastEducation_13: "",
      pastEducation_14: {},
      pastEducation_14a: "",
      plansForSchool_1: {},
      plansForSchool_1a: "",
      plansForSchool_2: "",
      plansForSchool_3: "",
      plansForSchool_4: "",
      plansForSchool_4a: "",
      plansForSchool_4b: "",
      plansForSchool_5: "",
      plansForSchool_6: "",
      educationPrograms: [],
      hadJob_1: "",
      past_jobs: [],
      military_1: "",
      military_2: "",
      military_3: undefined,
      military_4: undefined,
      military_5: "",
      military_6: "",
      cultural_1: "",
      cultural_2: "",
      cultural_3: "",
      cultural_4: "",
      cultural_5: "",
      mental_1: "",
      mental_2: "",
      mental_3: "",
      mental_4: "",
      mental_5: "",
      mental_6: "",
      substanceUse_1: "",
      substanceUse_2: "",
      substanceUse_3: "",
      substanceUse_4: "",
      physical_1: "",
      physical_2: "",
      physical_3: "",
      physical_4: "",
      physical_5: "",
      physical_6: "",
      physical_7: "",
      physical_8: "",
      physical_9: "",
      physical_10: 0,
      physical_11: "",
      physical_12: 0,
      physical_13: 0,
      physical_14: "",
      cognitive_1: "",
      cognitive_2: "",
      cognitive_3: "",
      cognitive_4: "",
      readyJob_1: "",
      readyJob_2: "",
      readyJob_3: "",
      readyJob_4: "",
      interpersonalSkills_1: "",
      interpersonalSkills_2: "",
      interpersonalSkills_3: "",
      interpersonalSkills_4: "",
      interpersonalSkills_5: "",
      benefits_received: {},
      benefits_received_other: "",
      benefits_1: "",
      benefits_2: "",
      benefits_3: "",
      legal_1: "",
      legal_2: "",
      legal_3: "",
      legal_3a: "",
      legal_3b: "",
      legal_3c: "",
      legal_4: "",
      legal_4a: "",
      legal_convictions: [],
      daily_1: "",
      daily_2: "",
      daily_3: "",
      daily_4: "",
      daily_5: "",
      networking_1: "",
      networking_contacts: [],
    },
    validate: (data) => {
      let errors = {}
      if (data.military_3 && data.military_4) {
        if (data.military_4 < data.military_3) {
          errors.military_3 =
            "Start date can not be greater than Discharge date"
        }
      }
      if (data.legal_3c) {
        if (!validateEmail(data.legal_3c)) {
          errors.legal_3c = "Invalid email address"
        }
      }
      return errors
    },
    onSubmit: () => {
      editCareerProfile ? editCareerData() : saveCareerData()
    },
  })
  useEffect(() => {
    if (editCareerProfile) {
      if (editCareerProfile.education6 === "Yes") {
        setExtraEducationSections(true)
      }
      formik.setFieldValue(
        careerProfileLabels.workGoals.workGoals_1.value,
        editCareerProfile.workGoals1
      )
      formik.setFieldValue(
        careerProfileLabels.workGoals.workGoals_2.value,
        editCareerProfile.workGoals2
      )
      formik.setFieldValue(
        careerProfileLabels.workGoals.workGoals_3.value,
        editCareerProfile.workGoals3
      )
      formik.setFieldValue(
        careerProfileLabels.workGoals.workGoals_3.value,
        editCareerProfile.workGoals3
      )
      formik.setFieldValue(
        careerProfileLabels.workGoals.workGoals_4.value,
        editCareerProfile.workGoals4
      )
      formik.setFieldValue(
        careerProfileLabels.workGoals.workGoals_5.value,
        editCareerProfile.workGoals5
      )
      formik.setFieldValue(
        careerProfileLabels.workGoals.workGoals_6.value,
        editCareerProfile.workGoals6
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_1.value,
        editCareerProfile.education1
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_1a.value,
        editCareerProfile.education1a
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_2.value,
        editCareerProfile.education2
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_3.value,
        editCareerProfile.education3
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_3a.value,
        editCareerProfile.education3a
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_4.value,
        editCareerProfile.education4
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_4a.value,
        editCareerProfile.education4a
      )
      formik.setFieldValue(
        "educationPrograms",
        editCareerProfile.educationPrograms ?? []
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_5.value,
        editCareerProfile.education5
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_5a.value,
        editCareerProfile.education5a
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_6.value,
        editCareerProfile.education6
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_6a.value,
        editCareerProfile.education6a
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_6b.value,
        editCareerProfile.education6b
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_6c.value,
        editCareerProfile.education6c
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_6d.value,
        editCareerProfile.education6d
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_6e.value,
        editCareerProfile.education6e
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_6e1.value,
        editCareerProfile.education6e1
          ? new Date(editCareerProfile.education6e1)
          : undefined
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_6f.value,
        editCareerProfile.education6f
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_6g.value,
        editCareerProfile.education6g
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_6h.value,
        editCareerProfile.education6h
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_6i.value,
        editCareerProfile.education6i
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_6i1.value,
        editCareerProfile.education6i
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_6i2.value,
        editCareerProfile.education6i
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_6i3.value,
        editCareerProfile.education6i
      )
      formik.setFieldValue(
        careerProfileLabels.education.education_6j.value,
        editCareerProfile.education6j
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_1.value,
        editCareerProfile.pastEducation1
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_1a.value,
        editCareerProfile.pastEducation1a
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_2.value,
        editCareerProfile.pastEducation2
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_2a.value,
        editCareerProfile.pastEducation2a
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_3.value,
        editCareerProfile.pastEducation3
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_3a.value,
        editCareerProfile.pastEducation3a
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_4.value,
        editCareerProfile.pastEducation4
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_4a.value,
        editCareerProfile.pastEducation4a
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_5.value,
        editCareerProfile.pastEducation5
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_5a.value,
        editCareerProfile.pastEducation5a
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_6.value,
        editCareerProfile.pastEducation6
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_6a.value,
        editCareerProfile.pastEducation6a
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_7.value,
        editCareerProfile.pastEducation7
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_7a.value,
        editCareerProfile.pastEducation7a
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_8.value,
        editCareerProfile.pastEducation8
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_8a.value,
        editCareerProfile.pastEducation8a
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_9.value,
        editCareerProfile.pastEducation9
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_9a.value,
        editCareerProfile.pastEducation9a
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_10.value,
        editCareerProfile.pastEducation10
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_10a.value,
        editCareerProfile.pastEducation10a
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_10b.value,
        editCareerProfile.pastEducation10b
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_11.value,
        editCareerProfile.pastEducation11
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_12.value,
        editCareerProfile.pastEducation12
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_12a.value,
        editCareerProfile.pastEducation12a
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_12b.value,
        editCareerProfile.pastEducation12b
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_13.value,
        editCareerProfile.pastEducation13
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_14.value,
        {
          arabic: editCareerProfile.pastEducation14_Arabic,
          chineseCambodian: editCareerProfile.pastEducation14_ChineseCambodian,
          chuukese: editCareerProfile.pastEducation14_Chuukese,
          hmong: editCareerProfile.pastEducation14_Hmong,
          laotian: editCareerProfile.pastEducation14_Laotian,
          russian: editCareerProfile.pastEducation14_Russian,
          spanish: editCareerProfile.pastEducation14_Spanish,
          tagalog: editCareerProfile.pastEducation14_Tagalog,
          chineseMandarin: editCareerProfile.pastEducation14_ChineseMandarin,
          english: editCareerProfile.pastEducation14_English,
          korean: editCareerProfile.pastEducation14_Korean,
          marshallese: editCareerProfile.pastEducation14_Marshallese,
          somali: editCareerProfile.pastEducation14_Somali,
          swahili: editCareerProfile.pastEducation14_Swahili,
          vietnamese: editCareerProfile.pastEducation14_Vietnamese,
          cambodian: editCareerProfile.pastEducation14_Cambodian,
          other: editCareerProfile.pastEducation14_Other,
        }
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_14a.value,
        editCareerProfile.pastEducation14a
      )
      formik.setFieldValue(
        careerProfileLabels.plansForSchoolAndTraining.plansForSchool_1.value,
        {
          accessToAComputer:
            editCareerProfile.plansForSchool1_AccessToAComputer,
          quietPlaceToStudy:
            editCareerProfile.plansForSchool1_QuietPlaceToStudy,
          financialAid: editCareerProfile.plansForSchool1_FinancialAid,
          mentalHealthSupport:
            editCareerProfile.plansForSchool1_MentalHealthSupport,
          helpWithTransitRoute:
            editCareerProfile.plansForSchool1_HelpWithTransitRoute,
          helpWithStudyCalendar:
            editCareerProfile.plansForSchool1_HelpWithStudyCalendar,
          helpNavigatingCampus:
            editCareerProfile.plansForSchool1_HelpNavigatingCampus,
          helpTalkingToTeachers:
            editCareerProfile.plansForSchool1_HelpTalkingToTeachers,
          computingLiteracy:
            editCareerProfile.plansForSchool1_ComputingLiteracy,
          transitCard: editCareerProfile.plansForSchool1_TransitCard,
          bookSupplies: editCareerProfile.plansForSchool1_BookSupplies,
          elderCare: editCareerProfile.plansForSchool1_ElderCare,
          helpStudying: editCareerProfile.plansForSchool1_HelpStudying,
          childCare: editCareerProfile.plansForSchool1_ChildCare,
          moreSupportFromFamily:
            editCareerProfile.plansForSchool1_MoreSupportFromFamily,
          other: editCareerProfile.plansForSchool1_Other,
        }
      )
      formik.setFieldValue(
        careerProfileLabels.plansForSchoolAndTraining.plansForSchool_1a.value,
        editCareerProfile.plansForSchool1a
      )
      formik.setFieldValue(
        careerProfileLabels.plansForSchoolAndTraining.plansForSchool_2.value,
        editCareerProfile.plansForSchool2
      )
      formik.setFieldValue(
        careerProfileLabels.plansForSchoolAndTraining.plansForSchool_3.value,
        editCareerProfile.plansForSchool3
      )
      formik.setFieldValue(
        careerProfileLabels.plansForSchoolAndTraining.plansForSchool_4.value,
        editCareerProfile.plansForSchool4
      )
      formik.setFieldValue(
        careerProfileLabels.plansForSchoolAndTraining.plansForSchool_4a.value,
        editCareerProfile.plansForSchool4a
      )
      formik.setFieldValue(
        careerProfileLabels.plansForSchoolAndTraining.plansForSchool_4b.value,
        editCareerProfile.plansForSchool4b
      )
      formik.setFieldValue(
        careerProfileLabels.plansForSchoolAndTraining.plansForSchool_5.value,
        editCareerProfile.plansForSchool5
      )
      formik.setFieldValue(
        careerProfileLabels.plansForSchoolAndTraining.plansForSchool_6.value,
        editCareerProfile.plansForSchool6
      )
      formik.setFieldValue(
        careerProfileLabels.workExperience.workExperience_1.value,
        editCareerProfile.hadJob1
      )
      formik.setFieldValue("past_jobs", editCareerProfile.pastJobs ?? [])
      formik.setFieldValue(
        careerProfileLabels.militaryExperience.militaryExperience_1.value,
        editCareerProfile.military1
      )
      formik.setFieldValue(
        careerProfileLabels.militaryExperience.militaryExperience_2.value,
        editCareerProfile.military2
      )
      formik.setFieldValue(
        careerProfileLabels.militaryExperience.militaryExperience_3.value,
        editCareerProfile.military3
          ? new Date(editCareerProfile.military3)
          : undefined
      )
      formik.setFieldValue(
        careerProfileLabels.militaryExperience.militaryExperience_4.value,
        editCareerProfile.military4
          ? new Date(editCareerProfile.military4)
          : undefined
      )
      formik.setFieldValue(
        careerProfileLabels.militaryExperience.militaryExperience_5.value,
        editCareerProfile.military5
      )
      formik.setFieldValue(
        careerProfileLabels.militaryExperience.militaryExperience_6.value,
        editCareerProfile.military6
      )
      formik.setFieldValue(
        careerProfileLabels.culturalBackground.culturalBackground_1.value,
        editCareerProfile.cultural1
      )
      formik.setFieldValue(
        careerProfileLabels.culturalBackground.culturalBackground_2.value,
        editCareerProfile.cultural2
      )
      formik.setFieldValue(
        careerProfileLabels.culturalBackground.culturalBackground_3.value,
        editCareerProfile.cultural3
      )
      formik.setFieldValue(
        careerProfileLabels.culturalBackground.culturalBackground_4.value,
        editCareerProfile.cultural4
      )
      formik.setFieldValue(
        careerProfileLabels.culturalBackground.culturalBackground_5.value,
        editCareerProfile.cultural5
      )
      formik.setFieldValue(
        careerProfileLabels.mentalHealth.mentalHealth_1.value,
        editCareerProfile.mental1
      )
      formik.setFieldValue(
        careerProfileLabels.mentalHealth.mentalHealth_2.value,
        editCareerProfile.mental2
      )
      formik.setFieldValue(
        careerProfileLabels.mentalHealth.mentalHealth_3.value,
        editCareerProfile.mental3
      )
      formik.setFieldValue(
        careerProfileLabels.mentalHealth.mentalHealth_4.value,
        editCareerProfile.mental4
      )
      formik.setFieldValue(
        careerProfileLabels.mentalHealth.mentalHealth_5.value,
        editCareerProfile.mental5
      )
      formik.setFieldValue(
        careerProfileLabels.mentalHealth.mentalHealth_6.value,
        editCareerProfile.mental6
      )
      formik.setFieldValue(
        careerProfileLabels.substanceUse.substanceUse_1.value,
        editCareerProfile.substanceUse1
      )
      formik.setFieldValue(
        careerProfileLabels.substanceUse.substanceUse_2.value,
        editCareerProfile.substanceUse2
      )
      formik.setFieldValue(
        careerProfileLabels.substanceUse.substanceUse_3.value,
        editCareerProfile.substanceUse3
      )
      formik.setFieldValue(
        careerProfileLabels.substanceUse.substanceUse_4.value,
        editCareerProfile.substanceUse4
      )
      formik.setFieldValue(
        careerProfileLabels.physicalHealth.physicalHealth_1.value,
        editCareerProfile.physical1
      )
      formik.setFieldValue(
        careerProfileLabels.physicalHealth.physicalHealth_2.value,
        editCareerProfile.physical2
      )
      formik.setFieldValue(
        careerProfileLabels.physicalHealth.physicalHealth_3.value,
        editCareerProfile.physical3
      )
      formik.setFieldValue(
        careerProfileLabels.physicalHealth.physicalHealth_4.value,
        editCareerProfile.physical4
      )
      formik.setFieldValue(
        careerProfileLabels.physicalHealth.physicalHealth_5.value,
        editCareerProfile.physical5
      )
      formik.setFieldValue(
        careerProfileLabels.physicalHealth.physicalHealth_6.value,
        editCareerProfile.physical6
      )
      formik.setFieldValue(
        careerProfileLabels.physicalHealth.physicalHealth_7.value,
        editCareerProfile.physical7
      )
      formik.setFieldValue(
        careerProfileLabels.physicalHealth.physicalHealth_8.value,
        editCareerProfile.physical8
      )
      formik.setFieldValue(
        careerProfileLabels.physicalHealth.physicalHealth_9.value,
        editCareerProfile.physical9
      )
      formik.setFieldValue(
        careerProfileLabels.physicalHealth.physicalHealth_10.value,
        editCareerProfile.physical10
      )
      formik.setFieldValue(
        careerProfileLabels.physicalHealth.physicalHealth_11.value,
        editCareerProfile.physical11
      )
      formik.setFieldValue(
        careerProfileLabels.physicalHealth.physicalHealth_12.value,
        editCareerProfile.physical12
      )
      formik.setFieldValue(
        careerProfileLabels.physicalHealth.physicalHealth_13.value,
        editCareerProfile.physical13
      )
      formik.setFieldValue(
        careerProfileLabels.physicalHealth.physicalHealth_14.value,
        editCareerProfile.physical14
      )
      formik.setFieldValue(
        careerProfileLabels.cognitiveHealth.cognitiveHealth_1.value,
        editCareerProfile.cognitive1
      )
      formik.setFieldValue(
        careerProfileLabels.cognitiveHealth.cognitiveHealth_2.value,
        editCareerProfile.cognitive2
      )
      formik.setFieldValue(
        careerProfileLabels.cognitiveHealth.cognitiveHealth_3.value,
        editCareerProfile.cognitive3
      )
      formik.setFieldValue(
        careerProfileLabels.cognitiveHealth.cognitiveHealth_4.value,
        editCareerProfile.cognitive4
      )
      formik.setFieldValue(
        careerProfileLabels.gettingReadyJob.gettingReadyForJob_1.value,
        editCareerProfile.readyJob1
      )
      formik.setFieldValue(
        careerProfileLabels.gettingReadyJob.gettingReadyForJob_2.value,
        editCareerProfile.readyJob2
      )
      formik.setFieldValue(
        careerProfileLabels.gettingReadyJob.gettingReadyForJob_3.value,
        editCareerProfile.readyJob3
      )
      formik.setFieldValue(
        careerProfileLabels.gettingReadyJob.gettingReadyForJob_4.value,
        editCareerProfile.readyJob4
      )
      formik.setFieldValue(
        careerProfileLabels.interpersonalSkills.interpersonalSkills_1.value,
        editCareerProfile.interpersonalSkills1
      )
      formik.setFieldValue(
        careerProfileLabels.interpersonalSkills.interpersonalSkills_2.value,
        editCareerProfile.interpersonalSkills2
      )
      formik.setFieldValue(
        careerProfileLabels.interpersonalSkills.interpersonalSkills_3.value,
        editCareerProfile.interpersonalSkills3
      )
      formik.setFieldValue(
        careerProfileLabels.interpersonalSkills.interpersonalSkills_4.value,
        editCareerProfile.interpersonalSkills4
      )
      formik.setFieldValue(
        careerProfileLabels.interpersonalSkills.interpersonalSkills_5.value,
        editCareerProfile.interpersonalSkills5
      )
      formik.setFieldValue(
        careerProfileLabels.benefits.benefits_1.value,
        editCareerProfile.benefits1
      )
      formik.setFieldValue(
        careerProfileLabels.benefits.benefits_2.value,
        editCareerProfile.benefits2
      )
      formik.setFieldValue(
        careerProfileLabels.benefits.benefits_3.value,
        editCareerProfile.benefits3
      )
      formik.setFieldValue(
        careerProfileLabels.benefits.benefits_received_other.value,
        editCareerProfile.benefitsOtherDesc
      )
      formik.setFieldValue(
        careerProfileLabels.benefits.benefits_received.value,
        {
          combatRelated: editCareerProfile.benefitsCombatRelated,
          housing: editCareerProfile.benefitsHousing,
          medicare: editCareerProfile.benefitsMedicare,
          retirement: editCareerProfile.benefitsRetirement,
          ssi: editCareerProfile.benefitsSSI,
          other: editCareerProfile.benefitsOther,
          foodStamps: editCareerProfile.benefitsFoodStamps,
          medicaid: editCareerProfile.benefitsMedicaid,
          nonCombat: editCareerProfile.benefitsNonCombat,
          ssdi: editCareerProfile.benefitsSSDI,
          tanf: editCareerProfile.benefitsTANF,
        }
      )
      formik.setFieldValue(
        careerProfileLabels.legalHistory.legalHistory_1.value,
        editCareerProfile.legal1
      )
      formik.setFieldValue(
        careerProfileLabels.legalHistory.legalHistory_2.value,
        editCareerProfile.legal2
      )
      formik.setFieldValue(
        careerProfileLabels.legalHistory.legalHistory_3.value,
        editCareerProfile.legal3
      )
      formik.setFieldValue(
        careerProfileLabels.legalHistory.legalHistory_3a.value,
        editCareerProfile.legal3a
      )
      formik.setFieldValue(
        careerProfileLabels.legalHistory.legalHistory_3b.value,
        editCareerProfile.legal3b
      )
      formik.setFieldValue(
        careerProfileLabels.legalHistory.legalHistory_3c.value,
        editCareerProfile.legal3c
      )
      formik.setFieldValue(
        careerProfileLabels.legalHistory.legalHistory_4.value,
        editCareerProfile.legal4
      )
      formik.setFieldValue(
        careerProfileLabels.legalHistory.legalHistory_convictions.value,
        editCareerProfile.convictions ?? []
      )
      formik.setFieldValue(
        careerProfileLabels.legalHistory.legalHistory_4.value,
        editCareerProfile.legal4
      )
      formik.setFieldValue(
        careerProfileLabels.legalHistory.legalHistory_4a.value,
        editCareerProfile.legal4a
      )
      formik.setFieldValue(
        careerProfileLabels.dailyActivities.dailyActivities_1.value,
        editCareerProfile.daily1
      )
      formik.setFieldValue(
        careerProfileLabels.dailyActivities.dailyActivities_2.value,
        editCareerProfile.daily2
      )
      formik.setFieldValue(
        careerProfileLabels.dailyActivities.dailyActivities_3.value,
        editCareerProfile.daily3
      )
      formik.setFieldValue(
        careerProfileLabels.dailyActivities.dailyActivities_4.value,
        editCareerProfile.daily4
      )
      formik.setFieldValue(
        careerProfileLabels.dailyActivities.dailyActivities_5.value,
        editCareerProfile.daily5
      )
      formik.setFieldValue(
        "networking_contacts",
        editCareerProfile.networkingContacts ?? []
      )
      formik.setFieldValue(
        careerProfileLabels.networkingContacts.networkingContacts_1.value,
        editCareerProfile.networking1
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editCareerProfile])

  const editCareerData = async () => {
    try {
      setLoading(true)
      const config = {
        headers: {
          Authorization: `Bearer ${userCtx.tokenEmployment}`,
        },
      }
      return axios
        .put(
          `${employmentApiUrl()}/careerProfile`,
          buildCareerProfileModel(),
          config
        )
        .then((result) => {
          update(result.data)
          formik.resetForm()
          setLoading(false)
        })
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }
  const saveCareerData = async () => {
    try {
      setLoading(true)
      const config = {
        headers: {
          Authorization: `Bearer ${userCtx.tokenEmployment}`,
        },
      }
      return axios
        .post(
          `${employmentApiUrl()}/careerProfile`,
          buildCareerProfileModel(),
          config
        )
        .then((result) => {
          update(result.data)
          formik.resetForm()
          setLoading(false)
        })
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }
  const buildCareerProfileModel = () => {
    return {
      Id: editCareerProfile ? editCareerProfile?.id : uuidv4(),
      OrganizationId: userCtx.session.user.organization_id,
      ParticipantId: userCtx.participant_id,
      ReferralId: userCtx.currentActiveReferral,
      WorkGoals1: formik.values.workGoals_1,
      WorkGoals2: formik.values.workGoals_2,
      WorkGoals3: formik.values.workGoals_3,
      WorkGoals4: formik.values.workGoals_4,
      WorkGoals5: formik.values.workGoals_5,
      WorkGoals6: formik.values.workGoals_6,
      Education1: formik.values.education_1,
      Education1a: formik.values.education_1a,
      Education2: formik.values.education_2,
      Education3: formik.values.education_3,
      Education3a: formik.values.education_3a,
      Education4: formik.values.education_4,
      Education4a: formik.values.education_4a,
      Education5: formik.values.education_5,
      Education5a: formik.values.education_5a,
      Education6: formik.values.education_6,
      Education6a: formik.values.education_6a,
      Education6b: formik.values.education_6b,
      Education6c: formik.values.education_6c,
      Education6d: formik.values.education_6d,
      Education6e: formik.values.education_6e,
      Education6e1: formik.values.education_6e1,
      Education6f: formik.values.education_6f,
      Education6g: formik.values.education_6g,
      Education6h: formik.values.education_6h,
      Education6i: formik.values.education_6i,
      Education6i1: formik.values.education_6i1,
      Education6i2: formik.values.education_6i2,
      Education6i3: formik.values.education_6i3,
      Education6j: formik.values.education_6j,
      PastEducation1: formik.values.pastEducation_1,
      PastEducation1a: formik.values.pastEducation_1a,
      PastEducation2: formik.values.pastEducation_2,
      PastEducation2a: formik.values.pastEducation_2a,
      PastEducation3: formik.values.pastEducation_3,
      PastEducation3a: formik.values.pastEducation_3a,
      PastEducation4: formik.values.pastEducation_4,
      PastEducation4a: formik.values.pastEducation_4a,
      PastEducation5: formik.values.pastEducation_5,
      PastEducation5a: formik.values.pastEducation_5a,
      PastEducation6: formik.values.pastEducation_6,
      PastEducation6a: formik.values.pastEducation_6a,
      PastEducation7: formik.values.pastEducation_7,
      PastEducation7a: formik.values.pastEducation_7a,
      PastEducation8: formik.values.pastEducation_8,
      PastEducation8a: formik.values.pastEducation_8a,
      PastEducation9: formik.values.pastEducation_9,
      PastEducation9a: formik.values.pastEducation_9a,
      PastEducation10: formik.values.pastEducation_10,
      PastEducation10a: formik.values.pastEducation_10a,
      PastEducation10b: formik.values.pastEducation_10b,
      PastEducation11: formik.values.pastEducation_11,
      PastEducation12: formik.values.pastEducation_12,
      PastEducation12a: formik.values.pastEducation_12a,
      PastEducation12b: formik.values.pastEducation_12b,
      PastEducation13: formik.values.pastEducation_13,
      PastEducation14_Arabic: formik.values.pastEducation_14.arabic,
      PastEducation14_ChineseCambodian:
        formik.values.pastEducation_14.chineseCambodian,
      PastEducation14_Chuukese: formik.values.pastEducation_14.chuukese,
      PastEducation14_Hmong: formik.values.pastEducation_14.hmong,
      PastEducation14_Laotian: formik.values.pastEducation_14.laotian,
      PastEducation14_Russian: formik.values.pastEducation_14.russian,
      PastEducation14_Spanish: formik.values.pastEducation_14.spanish,
      PastEducation14_Tagalog: formik.values.pastEducation_14.tagalog,
      PastEducation14_Cambodian: formik.values.pastEducation_14.cambodian,
      PastEducation14_ChineseMandarin:
        formik.values.pastEducation_14.chineseMandarin,
      PastEducation14_English: formik.values.pastEducation_14.english,
      PastEducation14_Korean: formik.values.pastEducation_14.korean,
      PastEducation14_Marshallese: formik.values.pastEducation_14.marshallese,
      PastEducation14_Somali: formik.values.pastEducation_14.somali,
      PastEducation14_Swahili: formik.values.pastEducation_14.swahili,
      PastEducation14_Vietnamese: formik.values.pastEducation_14.vietnamese,
      PastEducation14_Other: formik.values.pastEducation_14.other,
      PastEducation14a: formik.values.pastEducation_14a,
      PlansForSchool1_AccessToAComputer:
        formik.values.plansForSchool_1.accessToAComputer,
      PlansForSchool1_QuietPlaceToStudy:
        formik.values.plansForSchool_1.quietPlaceToStudy,
      PlansForSchool1_FinancialAid: formik.values.plansForSchool_1.financialAid,
      PlansForSchool1_MentalHealthSupport:
        formik.values.plansForSchool_1.mentalHealthSupport,
      PlansForSchool1_HelpWithTransitRoute:
        formik.values.plansForSchool_1.helpWithTransitRoute,
      PlansForSchool1_HelpWithStudyCalendar:
        formik.values.plansForSchool_1.helpWithStudyCalendar,
      PlansForSchool1_HelpNavigatingCampus:
        formik.values.plansForSchool_1.helpNavigatingCampus,
      PlansForSchool1_HelpTalkingToTeachers:
        formik.values.plansForSchool_1.helpTalkingToTeachers,
      PlansForSchool1_ComputingLiteracy:
        formik.values.plansForSchool_1.computingLiteracy,
      PlansForSchool1_TransitCard: formik.values.plansForSchool_1.transitCard,
      PlansForSchool1_BookSupplies: formik.values.plansForSchool_1.bookSupplies,
      PlansForSchool1_ElderCare: formik.values.plansForSchool_1.elderCare,
      PlansForSchool1_HelpStudying: formik.values.plansForSchool_1.helpStudying,
      PlansForSchool1_ChildCare: formik.values.plansForSchool_1.childCare,
      PlansForSchool1_MoreSupportFromFamily:
        formik.values.plansForSchool_1.moreSupportFromFamily,
      PlansForSchool1_Other: formik.values.plansForSchool_1.other,
      PlansForSchool1a: formik.values.plansForSchool_1a,
      PlansForSchool2: formik.values.plansForSchool_2,
      PlansForSchool3: formik.values.plansForSchool_3,
      PlansForSchool4: formik.values.plansForSchool_4,
      PlansForSchool4a: formik.values.plansForSchool_4a,
      PlansForSchool4b: formik.values.plansForSchool_4b,
      PlansForSchool5: formik.values.plansForSchool_5,
      PlansForSchool6: formik.values.plansForSchool_6,
      EducationPrograms: buildEducationPrograms(),
      HadJob1: formik.values.hadJob_1,
      PastJobs: buildPastJobs(),
      Military1: formik.values.military_1,
      Military2: formik.values.military_2,
      Military3: formik.values.military_3,
      Military4: formik.values.military_4,
      Military5: formik.values.military_5,
      Military6: formik.values.military_6,
      Cultural1: formik.values.cultural_1,
      Cultural2: formik.values.cultural_2,
      Cultural3: formik.values.cultural_3,
      Cultural4: formik.values.cultural_4,
      Cultural5: formik.values.cultural_5,
      Mental1: formik.values.mental_1,
      Mental2: formik.values.mental_2,
      Mental3: formik.values.mental_3,
      Mental4: formik.values.mental_4,
      Mental5: formik.values.mental_5,
      Mental6: formik.values.mental_6,
      SubstanceUse1: formik.values.substanceUse_1,
      SubstanceUse2: formik.values.substanceUse_2,
      SubstanceUse3: formik.values.substanceUse_3,
      SubstanceUse4: formik.values.substanceUse_4,
      Physical1: formik.values.physical_1,
      Physical2: formik.values.physical_2,
      Physical3: formik.values.physical_3,
      Physical4: formik.values.physical_4,
      Physical5: formik.values.physical_5,
      Physical6: formik.values.physical_6,
      Physical7: formik.values.physical_7,
      Physical8: formik.values.physical_8,
      Physical9: formik.values.physical_9,
      Physical10: formik.values.physical_10,
      Physical11: formik.values.physical_11,
      Physical12: formik.values.physical_12,
      Physical13: formik.values.physical_13,
      Physical14: formik.values.physical_14,
      Cognitive1: formik.values.cognitive_1,
      Cognitive2: formik.values.cognitive_2,
      Cognitive3: formik.values.cognitive_3,
      Cognitive4: formik.values.cognitive_4,
      ReadyJob1: formik.values.readyJob_1,
      ReadyJob2: formik.values.readyJob_2,
      ReadyJob3: formik.values.readyJob_3,
      ReadyJob4: formik.values.readyJob_4,
      InterpersonalSkills1: formik.values.interpersonalSkills_1,
      InterpersonalSkills2: formik.values.interpersonalSkills_2,
      InterpersonalSkills3: formik.values.interpersonalSkills_3,
      InterpersonalSkills4: formik.values.interpersonalSkills_4,
      InterpersonalSkills5: formik.values.interpersonalSkills_5,
      BenefitsCombatRelated: formik.values.benefits_received.combatRelated,
      BenefitsHousing: formik.values.benefits_received.housing,
      BenefitsRetirement: formik.values.benefits_received.retirement,
      BenefitsSSI: formik.values.benefits_received.ssi,
      BenefitsOther: formik.values.benefits_received.other,
      BenefitsOtherDesc: formik.values.benefits_received_other,
      BenefitsFoodStamps: formik.values.benefits_received.foodStamps,
      BenefitsMedicaid: formik.values.benefits_received.medicaid,
      BenefitsMedicare: formik.values.benefits_received.medicare,
      BenefitsNonCombat: formik.values.benefits_received.nonCombat,
      BenefitsSSDI: formik.values.benefits_received.ssdi,
      BenefitsTANF: formik.values.benefits_received.tanf,
      Benefits1: formik.values.benefits_1,
      Benefits2: formik.values.benefits_2,
      Benefits3: formik.values.benefits_3,
      Legal1: formik.values.legal_1,
      Legal2: formik.values.legal_2,
      Legal3: formik.values.legal_3,
      Legal3a: formik.values.legal_3a,
      Legal3b: formik.values.legal_3b,
      Legal3c: formik.values.legal_3c,
      Legal4: formik.values.legal_4,
      Legal4a: formik.values.legal_4a,
      Convictions: buildConvictions(),
      Daily1: formik.values.daily_1,
      Daily2: formik.values.daily_2,
      Daily3: formik.values.daily_3,
      Daily4: formik.values.daily_4,
      Daily5: formik.values.daily_5,
      Networking1: formik.values.networking_1,
      NetworkingContacts: buildNetworkingContacts(),
      CreatedBy: editCareerProfile
        ? editCareerProfile.createdBy
        : userCtx.session.user.staff_id,
      UpdatedBy: editCareerProfile
        ? editCareerProfile.updatedBy
        : userCtx.session.user.staff_id,
    }
  }
  const buildEducationPrograms = () => {
    return formik.values.educationPrograms?.map((m) => {
      return {
        Id: m.new ? undefined : m.id,
        CareerProfileId: editCareerProfile?.id,
        Name: m.name,
        Country: m.country,
        City: m.city,
        State: m.state,
        StartDate: m.startDate,
        EndDate: m.endDate,
        TypeOfDegree: m.typeOfDegree,
        Complete: m.complete,
        whyNotComplete: m.whyNotComplete,
        LikeMostProgram: m.likeMostProgram,
        LikeLeastProgram: m.likeLeastProgram,
        FinancialAid: m.financialAid,
        TypeOfFinancialAid: m.typeOfFinancialAid,
        Degrees: m.degrees,
      }
    })
  }
  const buildPastJobs = () => {
    return formik.values.past_jobs?.map((m) => {
      return {
        Id: m.new ? undefined : m.id,
        JobTitle: m.jobTitle,
        Employer: m.employer,
        JobDuties: m.jobDuties,
        StartDate: m.startDate,
        EndDate: m.endDate,
        HoursPerWeek: m.hoursPerWeek,
        FindJob: m.findJob,
        LikeJob: m.likeJob,
        DislikeJob: m.dislikeJob,
        SupervisorJob: m.supervisorJob,
        CoworkersJob: m.coworkersJob,
        LeavingJob: m.leavingJob,
        RelevantInformation: m.relevantInformation,
        CareerProfileId: editCareerProfile?.id,
      }
    })
  }
  const buildConvictions = () => {
    return formik.values.legal_convictions?.map((m) => {
      return {
        Id: m.new ? undefined : m.id,
        Type: m.type,
        Year: m.year,
        Sentence: m.sentence,
        CareerProfileId: editCareerProfile?.id,
      }
    })
  }
  const buildNetworkingContacts = () => {
    return formik.values.networking_contacts?.map((n) => {
      return {
        Id: n.new ? undefined : n.id,
        Name: n.name,
        Type: n.type,
        Phone: n.phone,
        PrimaryPhone: n.primaryPhone,
        ContactPhone: n.contactPhone,
        ContactText: n.contactText,
        ContactVoiceMail: n.contactVoiceMail,
        Email: n.email,
        CareerProfileId: editCareerProfile?.id,
      }
    })
  }
  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h1 className={styles.view_title}>Create career profile</h1>
      </div>
      <h4
        style={{
          marginBottom: "2rem",
          fontWeight: 400,
          fontStyle: "normal",
          fontSize: "14px",
          lineHeight: "19px",
        }}
      >
        This form is to be completed by the employment/education specialist
        during the first few weeks of meeting with someone. Sources of
        information include: the person, the mental health treatment team,
        client records, and with permission, family members and previous
        employers. The profile should be updated with each new job and education
        experience using job start, job end, and education experience forms.
      </h4>
      <div className={styles.careerProfile_main}>
        <FormMenu
          activeForm={activeForm}
          setActiveForm={setActiveForm}
          formik={formik}
          closeForm={closeForm}
          saveData={formik.handleSubmit}
          editCareerProfile={editCareerProfile}
          extraEducationSections={extraEducationSections}
          loading={loading}
        />
        <FormContent
          activeForm={activeForm}
          update={update}
          formik={formik}
          setActiveForm={setActiveForm}
          viewExtraEducationSections={setExtraEducationSections}
        />
      </div>
    </>
  )
}
export default CareerProfileForm
